var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0_832_59)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_832_59",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_832_59",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_832_59",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAG9SURBVFiF7Zc9axVREEDPrKhB1Bd5IMqLpBCx0MY+EFutbLSwEBv/hv4AFf+BXURSWAgWQVCLdHbGzkLygShYafAL3x6LfcJyyV4J7L5VcJpl5s7eOTv3zt25AKiz6j110+5lQ72rDgBCnQVWgTNMV14DCwVwq4fgAGeBm6FuAaMeAAA2Qx0DRU8AZaj2FBzIf/k2cA2YAeaBpU4IMuVyI/Er1Jdt12QuA0/qSkSUwNO2E5ADmNvBNt82QG4JnqkzNb9F9UfbS/CnKlgHVoDjwEVgT9sJyAF8BZaB7xP9NLAIjIEHk3GAo8Al4D3wCHgzAT0FXAGOZAky2Xmc+I0m9leJPdSH6sEd5j6kruSWILcJfzbo47oxIgSuR8R2OkFEfAYuAx+agrRyBEfEt8zYJ+B+pwDqUH2uflSX1H2Jy4tOAYA7wHlgCFyl2nx1eds1wIVEP5foX7oGGCR6WhGNe2RafUDjYddXI/If4N8AGKn7a/rJyXOoHvhtVI8Be5N359T6n/NEU5C/oikte4xfFsC7HgG2Cqqmoy9ZDqtb6irVXW2asgYsAKAOrK7MG2q5y75yN1Kq6+pt9TDAL9mXjFa/59nVAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.d3b1ab11ea41e9e83b18009d714c0657.svg";
export { ForwardRef as ReactComponent };